import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable, map, take } from 'rxjs';

import { CustomIcons } from '@shared/models/custom-icons';
import { CatalogService } from '@shared/services/catalog.service';
import { CatalogItemFieldsVM } from '@shared/models/shared-catalog.state';
import { CatalogItemValue } from '../../../../../models/catalog';
import { DownloadFileNames } from 'app/modules/data/modules/catalog-items-data/store/catalog-items.actions';

@Component({
  selector: 'app-catalog-item-card-link-modal',
  templateUrl: './catalog-item-card-link-modal.component.html',
  styleUrls: ['./catalog-item-card-link-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogItemCardLinkModalComponent implements OnInit {
  public icons = CustomIcons;
  public globalId: number;
  public catalogId: number;
  public title: string;
  public titleInner: string;
  public itemData$: Observable<CatalogItemValue>;
  public itemFields$: Observable<CatalogItemFieldsVM[]>;
  public loading = true;

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<CatalogItemCardLinkModalComponent>,
    private catalogService: CatalogService,
  ) {}

  public close(): void {
    this.dialogRef.close(false);
  }

  public ngOnInit(): void {
    this.itemFields$ = this.catalogService.getCatalogInfo(this.catalogId).pipe(
      take(1),
      map(res => res.response.find(x => x.id === this.catalogId)?.fields ?? [])
    );

    this.itemData$ = this.catalogService
      .getValueFields({
        criteria: `global_id = ${this.globalId}`,
        id: this.catalogId
      })
      .pipe(
        take(1),
        map(res => {
          this.loading = false;
          this.store.dispatch(new DownloadFileNames(res.response));
          return res.response?.[0];
        })
      );
  }
}
